<template>
  <div class="page-footer">
    <div class="first-content-outer">
      <div class="first-content">
        <div class="page-footer-content">
          <div class="logo-content-outer">
            <ul class="logo-content">
              <li>
                <a href="/">
                  <img :src="logImg" alt="" />
                </a>
              </li>
              <li class="sub-title slogan">
                <span class="web-slogan">
                  {{ slogan["web_slogan_" + language] }}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <ul class="text-content">
              <li class="sub-title">{{ translateTitle("关于") }}</li>
              <div >
                <li>        
                  <router-link
                    :to="routeSplicing(language, 'about-us')"
                    >{{ translateTitle("About Us") }}
                  </router-link
                  >
                </li>
              </div>
              <a :href="careersLink">
                <li>
                  <router-link
                    :to="routeSplicing(language, 'careers')"
                    >{{ translateTitle("Careers") }}
                  </router-link
                  >
                </li>
              </a>
              <a :href="'https://blog.ueex.com'" target="_blank">
                <li>{{ translateTitle("Blog & Academy") }}</li>
              </a>
              <!-- <a :href="membershipLink" target="_blank">
                <li>{{ translateTitle("membership program") }}</li>
              </a>
              <a :href="brokerLink" target="_blank">
                <li>{{ translateTitle("Broker") }}</li>
              </a>
              <a :href="feedbackLink" target="_blank">
                <li>{{ translateTitle("Feedback") }}</li>
              </a> -->
              <a :href="community" target="_blank">
                <li>{{ translateTitle("加入UEEx社群") }}</li>
              </a>
            </ul>
          </div>
          <div>
            <ul class="text-content">
              <li class="sub-title">{{ translateTitle("Support") }}</li>
              <!-- <a :href="FAQLink" target="_blank">
                <li>{{ translateTitle("FAQ") }}</li>
              </a> -->
              <a :href="announcementLink" target="_blank">
                <li>{{ translateTitle("Announcement center") }}</li>
              </a>
              <!-- <a :href="informationLink" target="_blank">
                <li>{{ translateTitle("Information center") }}</li>
              </a>
              <a :href="rateStandardLink" target="_blank">
                <li>{{ translateTitle("Rate Standard") }}</li>
              </a> -->
              <a :href="'https://support.ueex.com/hc/en-us/articles/4541636441103-Rate-Standard'" target="_blank">
                <li>{{ translateTitle("Fees") }}</li>
              </a>
              <a :href="beginnerLink" target="_blank">
                <li>{{ translateTitle("Beginner's Guide") }}</li>
              </a>
              <a :href="'https://support.ueex.com/hc/en-us/categories/4414322139535-UEEx'" target="_blank">
                <li>{{ translateTitle("Help center") }}</li>
              </a>
            </ul>
          </div>

          <div>
            <ul class="text-content">
              <li class="sub-title">{{ translateTitle("条款") }}</li>
              <a :href="serviceLink" target="_blank">
                <li>{{ translateTitle("服务协议") }}</li>
              </a>
              <a :href="privacyLink" target="_blank">
                <li>{{ translateTitle("隐私协议") }}</li>
              </a>
              <a :href="lawEnforcementLink" target="_blank">
                <li>{{ translateTitle("Law enforcement") }}</li>
              </a>
              <!-- <a :href="statementUrl" target="_blank">
                <li>{{ translateTitle("免责声明") }}</li>
              </a> -->
            </ul>
          </div>
          <div>
            <ul class="text-content">
              <li class="sub-title">{{ translateTitle("App Download") }}</li>
              <a
                href="https://play.google.com/store/apps/details?id=com.ueasy8.app"
                target="_blank"
              >
                <li>{{ translateTitle("Android Download") }}</li>
              </a>

              <a
                href="https://apps.apple.com/us/app/ueex/id1610966246"
                target="_blank"
              >
                <li>{{ translateTitle("iOS Download") }}</li>
              </a>

              <li class="footer-icons">
                <a
                  v-for="(item, index) in contactUs"
                  :key="index"
                  :href="item.url"
                  target="_blank"
                >
                  <img :src="item.src" alt="" class="footer-icon" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- BJ页脚 -->
    </div>
    <div class="second-content V2 V3">
      <div>
        <p>
          ©2024, UEEx All Rights Reserved FINTRAC Registered
        </p>
      </div>
    </div>

    <el-dialog
      custom-class="langVisible_n"
      :visible.sync="langVisible"
      :show-close="false"
    >
      <img
        src="../../assets/img_n/close_icon.png"
        class="close_icon"
        @click="
          () => {
            langVisible = false;
          }
        "
      />
      <el-tabs v-model="activeName">
        <el-tab-pane :label="translateTitle('语言和地区')" name="first">
          <p class="pane-title">{{ translateTitle("选择语言和地区") }}</p>
          <ul>
            <li
              v-for="item in countryList"
              :key="item.value"
              @click="onLangClick(item)"
            >
              <!-- <img :src="item.img" alt="" /> -->
              <span :class="languageName == item.name ? 'red-lang-curr' : ''">{{
                item.name
              }}</span>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane :label="translateTitle('汇率')" name="second">
          <p class="pane-title">{{ translateTitle("选择汇率") }}</p>
          <ul>
            <li
              v-for="(item, index) in currencyMaps"
              :key="index"
              @click="onCurrencyChange(item.logic_name)"
            >
              <span :class="currency == item.abbreviate ? 'red-lang-curr' : ''">
                <!-- <img :src="item.icon" /> -->
                {{ `${item.mark} ${item.abbreviate}` }}
              </span>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { translateTitle } from "@/assets/js/i18n";
import { getLangPackage } from "@/assets/js/lang";
import {
  VUE_UNION_STATION,
  VUE_CHANNEL_ID,
  getEnv,
} from "@/assets/js/stationSetting";
import { apiGetStaticTableInfo } from "@/model/settings";
import routeSplicing from "@/assets/js/routeSplicing";
export default {
  components: {},
  computed: {
    ...mapGetters({
      userInfo: "user/userInfo",
      language: "user/language",
      currencys: "user/currency",
    }),
    language_name() {
      let name = "";
      this.countryList.forEach(item => {
        if (item.value == this.language) {
          name = item.name;
        }
      });
      return name;
    },
  },
  data() {
    return {
      slogan: "让金融更高效 让财富更自由",
      tgUrl: "",
      tipUrl: "",
      qrcodeTitle: "",
      rateUrl: "",
      serviceUrl: "",
      privacyUrl: "",
      statementUrl: "",
      helpUrl: "",
      community: "https://t.me/ueexglobal",
      projectName: "",
      logImg: "",
      apiUrl: "",
      contactUs: [
      ],
      partnerUrl:
        "https://bitda.zendesk.com/hc/en-001/categories/4907990999055-Partner",
      isHx: false,
      is5A: false,
      is8V: false,
      isB9: false,
      isBitda: false,
      hasAPI: false,
      isUeex: false,
      ueTwitter: "https://twitter.com/UEEx_official",
      ueInstagram: "https://www.instagram.com/ueex_official/",
      ueFacebook: "https://www.facebook.com/UEExOfficial/?ref=page_internal",
      ueYoutube: "https://www.youtube.com/channel/UCj2oZqzSWPbnCEwGkG_cVtQ",
      ueLinkedDin: "https://www.linkedin.com/company/ueex-technology",
      langVisible: false,
      currencyMaps: {},
      activeName: "first",
      languageName: "中文简体",
      currency: "CNY",
      countryList: [
        {
          name: "English",
          value: "en",
          // img: enUS,
        },
        {
          name: "日本語",
          value: "ja",
          // img: Ja,
        },
        {
          name: "한국인",
          value: "ko",
          // img: Ko,
        },

        {
          name: "Français",
          value: "fr",
          // img: fr,
        },
        {
          name: "Español",
          value: "es",
          // img: es,
        },
        {
          name: "Pусский",
          value: "ru",
          // img: ru,
        },
        {
          name: "Deutsch",
          value: "de",
          // img: de,
        },
        {
          name: "Português",
          value: "pt",
          // img: pt,
        },
        {
          name: "हिंदी",
          value: "hi",
          // img: hi,
        },
        {
          name: "Tiếng Việt",
          value: "vi",
          // img: vi,
        },
        {
          name: "Pilipino",
          value: "tl",
          // img: tl,
        },
        {
          name: "ภาษาไทย",
          value: "th",
          // img: th,
        },
        {
          name: "Türk",
          value: "tr",
          // img: tr,
        },
        {
          name: "Italiano",
          value: "it",
          // img: it,
        },
        {
          name: "bahasa Indonesia",
          value: "id",
          // img: id,
        },
        {
          name: "عربي",
          value: "ar",
          // img: ar,
        },
        {
          name: "中文简体",
          value: "zh_CN",
          // img: zhCN,
        },
        {
          name: "中文繁體",
          value: "zh_HK",
          // img: zhHK,
        },
      ],
      aboutUsLink: "", //
      careersLink: "",
      membershipLink: "",
      brokerLink: "",
      feedbackLink: "",
      FAQLink: "",
      announcementLink: "",
      informationLink: "",
      rateStandardLink: "",
      beginnerLink: "",
      serviceLink: "",
      privacyLink: "",
      lawEnforcementLink: ""
    };
  },
  created() {
    this.getStaticChainInfo();
    this.isUeex = true;
    this.logImg = require("../../assets/img/logo_UEEx.png");
    this.slogan = "让金融更高效 让财富更自由";

    this.slogan = JSON.parse(sessionStorage.getItem("solgan"));
    if (!JSON.parse(sessionStorage.getItem("clause"))) {
      getEnv();
    }
    let clauseList = JSON.parse(sessionStorage.getItem("clause"));
    let othersList = JSON.parse(sessionStorage.getItem("others"));
    let noticeList = JSON.parse(sessionStorage.getItem("zendesk_notice"));
    let qrcode = JSON.parse(sessionStorage.getItem("qrcode"));
    let about = JSON.parse(sessionStorage.getItem("about"));
    // this.contactUs = JSON.parse(sessionStorage.getItem("contact_us"));

    // console.log(338, this.contactUs)
    
    this.changeLink()
    this.initGoLink()

    if (othersList[0].language) {
      this.rateUrl = othersList[0].language[`url_${this.language}`];
    } else {
      this.rateUrl = othersList[0].url;
    }
    if (othersList[1]) {
      this.hasAPI = true;
      this.apiUrl = othersList[1].url;
    } else {
    }

    if (clauseList[0].language) {
      this.serviceUrl = clauseList[0].language[`url_${this.language}`];
    } else {
      this.serviceUrl = clauseList[0].url;
    }
    if (about[0].language) {
      this.tipUrl = about[0].language[`url_${this.language}`];
    } else {
      this.tipUrl = about[0].url;
    }
    if (clauseList[1].language) {
      this.privacyUrl = clauseList[1].language[`url_${this.language}`];
    } else {
      this.privacyUrl = clauseList[1].url;
    }

    if (clauseList[2].language) {
      this.statementUrl = clauseList[2].language[`url_${this.language}`];
    } else {
      this.statementUrl = clauseList[2].url;
    }
    if (about[1].language) {
      this.helpUrl = about[1].language[`url_${this.language}`];
    } else {
      this.helpUrl = about[1].url;
    }

    this.tgUrl = qrcode.ori_url;
    this.qrcodeTitle = qrcode.title;

    if (
      this.language == "zh-hk" ||
      this.language == "zh-tw" ||
      this.language == "zh_HK" ||
      this.language == "zh-TW"
    ) {
      this.partnerUrl =
        "https://bitda.zendesk.com/hc/zh-tw/categories/4907147995279-%E5%90%88%E4%BD%9C%E5%A4%A5%E4%BC%B4";
    } else if (this.language == "zh_CN") {
      // 假如浏览器语言是中文
      this.partnerUrl =
        "https://bitda.zendesk.com/hc/zh-cn/sections/4905697484431-%E6%88%90%E4%B8%BA-Bitda-%E7%9A%84%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4";
    } else {
      // 假如浏览器语言是英文
      this.partnerUrl =
        "https://bitda.zendesk.com/hc/en-001/categories/4907990999055-Partner";
    }

    if (this.language == "zh_CN" || this.language == "zh_HK") {
      this.ueTwitter = "https://twitter.com/UEEx_CN";
      this.ueInstagram = "https://www.instagram.com/ueex_cn/";
      this.ueFacebook =
        "https://www.facebook.com/UEExOfficial/?ref=page_internal";
      this.ueYoutube =
        "https://www.youtube.com/channel/UCj2oZqzSWPbnCEwGkG_cVtQ";
      this.ueLinkedDin = "https://www.linkedin.com/company/ueex-technology";
    }
    let currency = localStorage.getItem("currency") || "cny";
    let tempLang = localStorage.getItem("language");
    if (tempLang) {
      this.countryList.forEach(ele => {
        if (ele.value == tempLang) {
          this.imgUrl = require("../../assets/img/lang/f-" +
            ele.value +
            ".png");
          this.languageName = ele.name;
        }
      });
    } else {
      tempLang = "zh_CN";

      this.countryList.forEach(ele => {
        if (ele.value == tempLang) {
          this.imgUrl = require("../../assets/img/lang/f-" +
            ele.value +
            ".png");
          this.languageName = ele.name;
        }
      });
    }
    this.handleSelect(currency);
  },
  methods: {
    routeSplicing,
    translateTitle,
    ...mapActions({
      changeLanguage: "user/changeLanguage",
      changeCurrency: "user/changeCurrency",
    }),
    async getStaticChainInfo() {
      await apiGetStaticTableInfo(7).then(({ data }) => {
        this.currencyMaps = data;
      });
    },
    onMaskLangDialog() {
      this.langVisible = true;
    },
    onLangClick(item) {
      // this.imgUrl = require("../../assets/img/lang/f-" + item.value + ".png");
      const langPackage = getLangPackage([item.value]);
      this.languageName = item.name;
      this.$i18n.setLocaleMessage(item.value, langPackage[item.value]);
      this.changeLanguage(item.value);
      this.$i18n.locale = item.value;
      this.langVisible = false;
    },
    handleSelect(key) {
      if (key == "cny") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "hkd") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "aed") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "jpy") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "krw") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "usd") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "try") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "mmk") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "php") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "sgd") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "thb") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "vnd") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      } else if (key == "brl") {
        this.currency = key.toUpperCase();
        this.changeCurrency(key);
      }
    },
    onCurrencyChange(key) {
      this.currency = key.toUpperCase();
      this.changeCurrency(key);
      this.langVisible = false;

      if (this.isHx) {
        if (this.languageName == "中文简体") {
          this.logImg = require("../../assets/img/logo-zh.png");
        } else if (this.languageName == "中文繁體") {
          this.logImg = require("../../assets/img/logo-hk.png");
        } else {
          this.logImg = require("../../assets/img/logo.png");
        }
      }
    },
    onKycClick() {
      this.$router.push({
        path: "/kyc-notice",
      });
    },
    onAPIClick() {
      this.$emit("onApiClick");
    },
    onClickMore() {
      window.open(this.tipUrl);
    },
    changeLink() {
      if (this.language == "zh_CN") {
        this.community = "https://t.me/ueexCN"
        this.contactUs = [
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/telegram-logo.svg"),
                "url": "https://t.me/+c1rlt84kxVY0OTNk",
                "title": "Telegram"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/f-logo.svg"),
                "url": "https://www.facebook.com/UEExOfficial",
                "title": "Facebook"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/p-logo.svg"),
                "url": "https://www.instagram.com/ueex_official",
                "title": "Instagram"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/x-logo.svg"),
                "url": "https://x.com/UEEx_official",
                "title": "Twitter"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/yg-logo.svg"),
                "url": "",
                "title": "Youtube"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/in-logo.svg"),
                "url": "https://www.linkedin.com/company/ueex-technology",
                "title": "Linkedin"
            },
        ]
      } else {
        this.community = "https://t.me/ueexglobal"
        this.contactUs = [
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/telegram-logo.svg"),
                "url": "https://t.me/+c1rlt84kxVY0OTNk",
                "title": "Telegram"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/f-logo.svg"),
                "url": "https://www.facebook.com/UEExOfficial",
                "title": "Facebook"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/p-logo.svg"),
                "url": "https://www.instagram.com/ueex_official",
                "title": "Instagram"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/x-logo.svg"),
                "url": "https://x.com/UEEx_official",
                "title": "Twitter"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/yg-logo.svg"),
                "url": "",
                "title": "Youtube"
            },
            {
                "class": "iconf-4",
                "src": require("../../assets/img/footer/in-logo.svg"),
                "url": "https://www.linkedin.com/company/ueex-technology",
                "title": "Linkedin"
            },
        ]
      }
    },
    // 初始化跳转链接
    initGoLink() {
      if (this.language == "zh_CN") {
        this.aboutUsLink = window.location.origin + "/about-us";
        this.careersLink = window.location.origin + "/careers";
        this.membershipLink = "";
        this.brokerLink = "";
        this.feedbackLink = "";
        this.FAQLink = "";
        this.announcementLink = "https://support.ueex.com/hc/zh-cn/sections/4414322139663-%E5%AE%98%E6%96%B9%E5%85%AC%E5%91%8A";
        this.informationLink = "https://support.ueex.com/hc/zh-cn";
        this.rateStandardLink = "https://support.ueex.com/hc/zh-cn/articles/4541636441103-%E8%B4%B9%E7%8E%87%E6%A0%87%E5%87%86";
        this.beginnerLink = "https://support.ueex.com/hc/zh-cn/sections/10796705251087-%E6%96%B0%E7%94%A8%E6%88%B7%E6%8C%87%E5%8D%97";
        this.serviceLink = "https://support.ueex.com/hc/zh-cn/articles/4540170437903-%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE";
        this.privacyLink = "https://support.ueex.com/hc/zh-cn/articles/4414322139791-%E9%9A%90%E7%A7%81%E6%9D%A1%E6%AC%BE";
        this.lawEnforcementLink = "";
      } else if (this.language == "zh_HK") {
        this.aboutUsLink = window.location.origin + "/about-us";
        this.careersLink = window.location.origin + "/careers";
        this.membershipLink = "";
        this.brokerLink = "";
        this.feedbackLink = "";
        this.FAQLink = "";
        this.announcementLink = "https://support.ueex.com/hc/zh-tw/sections/4414322139663-%E5%AE%98%E6%96%B9%E5%85%AC%E5%91%8A";
        this.informationLink = "https://support.ueex.com/hc/zh-tw";
        this.rateStandardLink = "https://support.ueex.com/hc/zh-tw/articles/4541636441103-%E8%B2%BB%E7%8E%87%E6%A8%99%E6%BA%96";
        this.beginnerLink = "https://support.ueex.com/hc/zh-tw/sections/10796705251087-%E6%96%B0%E7%94%A8%E6%88%B6%E6%8C%87%E5%8D%97";
        this.serviceLink = "https://support.ueex.com/hc/zh-tw/articles/4540170437903-%E6%9C%8D%E5%8B%99%E5%8D%94%E8%AD%B0";
        this.privacyLink = "https://support.ueex.com/hc/zh-tw/articles/4414322139791-%E9%9A%B1%E7%A7%81%E6%A2%9D%E6%AC%BE";
        this.lawEnforcementLink = "";
      } else {
        this.aboutUsLink = window.location.origin + "/about-us";
        this.careersLink = window.location.origin + "/careers";
        this.membershipLink = "";
        this.brokerLink = "";
        this.feedbackLink = "";
        this.FAQLink = "";
        this.announcementLink = "https://support.ueex.com/hc/en-us/sections/4414322139663-Announcement";
        this.informationLink = "https://support.ueex.com/hc/en-us";
        this.rateStandardLink = "https://support.ueex.com/hc/en-us/articles/4541636441103-Rate-Standard";
        this.beginnerLink = "https://support.ueex.com/hc/en-us/sections/10796705251087-New-User-Guide";
        this.serviceLink = "https://support.ueex.com/hc/en-us/articles/4540170437903-Terms-of-Use";
        this.privacyLink = "https://support.ueex.com/hc/en-us/articles/4414322139791-Private-Policy";
        this.lawEnforcementLink = "";
      }
    },


  },
  watch: {
    language: {
        handler:function(newValue, oldValue) {
          this.changeLink()
          this.initGoLink()
          if (this.isHx) {
            if (newValue == "zh_CN") { // 中
              this.logImg = require("../../assets/img/logo-zh.png");
            } else if (newValue == "zh_HK") { // 繁
              this.logImg = require("../../assets/img/logo-hk.png");
            } else { // 英文
              this.logImg = require("../../assets/img/logo.png");
            }
          }
        
      },
      immediate: true
    }
  },
};
</script>
<style lang="scss">
.page-footer {
  padding: 50px 0 20px;
  // display: flex;
  // justify-content: center;
  .first-content-outer {
    width: 1200px;
    display: flex;
    justify-content: flex-start;
    margin: 0 auto;
  }
  .first-content {
    display: flex;
    justify-content: center;
  }
  .second-content {
    width: 1000px;
    margin: 0px auto;
    padding: 20px 90px;
    border-top: 1px solid #fcd535;
    color: #fcd535;
    &.V2 {
      border-top: 1px solid #7e8392;
      color: #7e8392;
    }
    &.V3 {
      border-top: none;
      margin-top: 20px;
      width: 1200px;
      p {
        margin-bottom: 0;
        color: #18181b;
      }
    }
    p {
      font-size: 14px;
      line-height: 2;
      margin-bottom: 10px;
      vertical-align: middle;
      img {
        width: 14px;
        height: 16px;
        vertical-align: middle;
      }
    }
  }
  // background-color: #17232c;
  background-color: #151617;
  color: #fff;
  text-align: center;
  user-select: none;

  // position: absolute;
  // bottom: 0;
  // left: 0;
  // width: 100%;
  .page-footer-content {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    // padding: 0px 360px;
    width: 1200px;
    .logo-content img {
      height: 42px;
    }

    .footer-icons {
      margin-top: 39px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 175px;
      .iconfont {
        font-size: 18px;
        color: #959da4;
        margin-right: 20px;
        cursor: pointer;
      }
      a {
        display: inline-block;
        .footer-icon {
          width: 32px;
          height: 32px;
          margin-right: 24px;
          margin-bottom: 10px;
        }
      }
    }
    .logo-content-outer {
      display: flex;
      flex-direction: column;
      .language-current {
        cursor: pointer;
        width: 200px;
        height: 40px;
        margin-top: 32px;
        padding: 10px;
        border-radius: 2px;
        border: solid 1px rgba(148, 158, 164, 0.5);
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        // font-weight: 500;
        color: #fff;
        .expand {
          width: 16px;
          height: 16px;
        }
      }
    }
    .logo-content {
      text-align: left;
      img {
        // width: 182px;
        // height: 42px;
        width: 152px;
        height: 44px;
      }
      .sub-title {
        font-size: 18px;
        color: #18181b;
        height: 20px;
        margin-top: 10px;
        vertical-align: middle;
        &.slogan {
          font-size: 14px;
          font-weight: 400;
        }
        .bitda-tg {
          width: 32px;
          height: 27px;
          margin-left: 13px;
          vertical-align: middle;
        }
      }
    }
    .tg-content {
      .qr_code_canvas {
        margin-bottom: 10px;
        canvas {
          border: 3px solid white;
        }
      }
      img {
        width: 80px;
        height: 80px;
      }
      li {
        font-size: 16px;
        margin-bottom: 13px;
        text-align: left;
      }
    }
    .text-content {
      vertical-align: top;
      li {
        color: #71717a;
        font-size: 16px;
        margin: 0 0 17px;
        text-align: left;
        cursor: pointer;
        a {
          color: #71717a;
          font-size: 16px;
          margin: 0 0 17px;
          text-align: left;
        }
      }
    }
  }
  .langVisible_n {
    z-index: 999;
    width: 840px;

    .close_icon {
      position: absolute;
      width: 14px;
      height: 14px;
      top: 28px;
      right: 30px;
      z-index: 10;
      cursor: pointer;
    }
    .el-dialog__header {
      height: 0px;
      padding: 0 !important;
    }
    .el-dialog__body {
      padding-top: 16px;
      .el-tabs__header {
        margin-bottom: 22px;
      }
      .el-tabs__active-bar {
        background-color: #c61b3d;
      }
      .el-tabs__item {
        font-size: 16px;
        font-weight: 500;
        color: #131f30;
        margin-bottom: 12px;
      }
      .pane-title {
        font-size: 16px;
        font-weight: 500;
        color: #131f30;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
    ul {
      // min-width: 700px;
      margin-left: 6px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
    }

    li {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      height: 48px;
      width: 25%;
      &:hover {
        color: black;
      }
      img {
        width: 28px;
        height: 28px;
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 16px;
        font-weight: 500;
        color: #202630;
      }
      .red-lang-curr {
        color: #c61b3d;
      }
    }
  }
}
</style>
